var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugType2Small(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,14c0-1.9296875-1.5703125-3.5-3.5-3.5S4,12.0703125,4,14s1.5703125,3.5,3.5,3.5S11,15.9296875,11,14z M7.5,15.5 C6.6728516,15.5,6,14.8271484,6,14s0.6728516-1.5,1.5-1.5S9,13.1728516,9,14S8.3271484,15.5,7.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,10.5c-1.9296875,0-3.5,1.5703125-3.5,3.5s1.5703125,3.5,3.5,3.5S28,15.9296875,28,14S26.4296875,10.5,24.5,10.5z  M24.5,15.5c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5S26,13.1728516,26,14S25.3271484,15.5,24.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,18c-1.9296875,0-3.5,1.5703125-3.5,3.5s1.5703125,3.5,3.5,3.5s3.5-1.5703125,3.5-3.5S22.4296875,18,20.5,18z  M20.5,23c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S21.3271484,23,20.5,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,18C9.5703125,18,8,19.5703125,8,21.5S9.5703125,25,11.5,25s3.5-1.5703125,3.5-3.5S13.4296875,18,11.5,18z M11.5,23 c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S12.3271484,23,11.5,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,14c0-1.9296875-1.5703125-3.5-3.5-3.5s-3.5,1.5703125-3.5,3.5s1.5703125,3.5,3.5,3.5S19.5,15.9296875,19.5,14z  M16,15.5c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S16.8271484,15.5,16,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8535156,2.265625C26.6679688,2.0947266,26.4257812,2,26.1738281,2H5.8261719 C5.5742188,2,5.3320312,2.0947266,5.1464844,2.265625C1.8759766,5.2929688,0,9.5703125,0,14c0,8.8222656,7.1777344,16,16,16 s16-7.1777344,16-16C32,9.5703125,30.1240234,5.2929688,26.8535156,2.265625z M16,28C8.2802734,28,2,21.7197266,2,14 c0-3.8037109,1.4970703-7.3388672,4.2255859-10h19.5488281C28.5029297,6.6611328,30,10.1962891,30,14 C30,21.7197266,23.7197266,28,16,28z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugType2Small);
export default __webpack_public_path__ + "static/media/plug-type-2--small.0ca9477162fbba07cf8f06c3aedbe69f.svg";
export { ForwardRef as ReactComponent };